import { useApolloClient } from "@apollo/client";
import { AuthClient } from "./auth";
import { SubscriptionsClient } from "./subscriptions";
import { SchoolsClient } from "./school";
import { QuestionClient } from "./question";
import { AssignmentClient } from "./assignment";
import { CoreClient } from "./core";
import { WondeClient } from "./wonde";
import { RagClient } from "./rag";
import { QuizClient } from "./quiz";
import { ApiAccessClient } from "./apiAccess";
import { SkillClient } from "./skill";
import { ModeratorClient } from "./moderator";
import { AssistantClient } from "./assistant";
import { MarketingClient } from "./marketing";
import { useMemo } from "react";

export const useApiClient = () => {
  const client = useApolloClient();

  return useMemo(
    () => ({
      client,
      users: new AuthClient(client),
      core: new CoreClient(client),
      subscriptions: new SubscriptionsClient(client),
      schools: new SchoolsClient(client),
      question: new QuestionClient(client),
      quiz: new QuizClient(client),
      assignment: new AssignmentClient(client),
      skill: new SkillClient(client),
      wonde: new WondeClient(client),
      rag: new RagClient(client),
      apiAccess: new ApiAccessClient(client),
      moderator: new ModeratorClient(client),
      assistant: new AssistantClient(client),
      marketing: new MarketingClient(client),
    }),
    [client],
  );
};
